import React, { useEffect, useState } from 'react'
import * as Styles from './SearchInput.style'
import { trim } from '../../../../utils/tools'
import { FormData } from '../../../Home/components/HomeSearchPage/searchType'
import { RouteProps, RouterProps, withRouter } from 'react-router'
import { SearchModel } from '../../../Home/components/HomeSearchPage/searchModel'
import { insertValueToStorage, HISTORY_TYPE } from './historyStorage'
const deleteIcon = 'https://static-1253442168.image.myqcloud.com/picture/11285307_4bc3220afc06392183c8492e2207344f.jpg'

interface IProps extends RouteProps, RouterProps {
    onSearch: (keyword: string) => void,
    keyword: string
}

const isEmptyKeyword = (keyword: string) => {
    return trim(keyword).length === 0
}

function SearchInput(props: IProps) {
    const [formData, setFormData] = useState<FormData>(null)
    const [placeholder, setPlaceholder] = useState<string>('搜索课程/专栏/直播间')
    const [keyword, setKeyword] = useState<string>(props.keyword)

    useEffect(() => {
        getPlaceholder()
    }, [])

    useEffect(() => {

        document.addEventListener('keydown', listenEnter)
        return () => {
            document.removeEventListener('keydown', listenEnter)
        }
    }, [keyword])

    async function getPlaceholder() {
        const data = await SearchModel.fetchSearchResult() as any
        if (data) {
            setFormData(data.form_data)
            setPlaceholder(data.form_data ? data.form_data.word : '')
        }
    }

    function checkShouldBacktoSearch(value: string) {
        if (!value) {
            props.history.goBack()
            return true
        }
        return false
    }

   // 跳转搜索结果页
    const onSearch = () => {
        const isSpecial = !!(formData && (keyword === formData.word || !keyword))
        // 特殊搜索
        if (isSpecial) {
            const url = formData.link

            if (!keyword) {
                insertValueToStorage(placeholder, HISTORY_TYPE.SPECIAL, url)
            } else {
                insertValueToStorage(keyword, HISTORY_TYPE.SPECIAL, url)
            }
            window.location.assign(url)
        } else {
            // 普通搜索
            if (!isEmptyKeyword(keyword)) {
                insertValueToStorage(keyword, HISTORY_TYPE.NORMAL)
                props.history.replace(`${props.location!.pathname}?keyword=${keyword}`)
                props.onSearch(keyword)
            }
        }
    }

    // 监听用户按下enter键，搜索用
    const listenEnter = (event: KeyboardEvent) => {
        if (event.keyCode === 13) {
            onSearch()
        }
    }

    // 记录用户输入值
    const onChangeKeyword = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!checkShouldBacktoSearch(e.target.value)) {
            setKeyword(e.target.value)
        }
    }

    const onClearKeyword = () => {
        checkShouldBacktoSearch('')
    }

    return (
        <div className={Styles.SearchWrap}>
            <form  className={Styles.SearchPageInputWrap} action="javascript:void(0)">
                <input type="search" autoFocus={true} className={Styles.SearchPageInput} onChange={onChangeKeyword} placeholder={placeholder} value={keyword}/>
                {keyword.length > 0 && <span onClick={onClearKeyword} className={Styles.deleteTypeText}>
                    <img src={deleteIcon} alt=""/></span>}
            </form>
            <button className={Styles.searchBtn} onClick={onSearch}>搜索</button>
        </div>
    )
}

export default withRouter(SearchInput as any) as any



// WEBPACK FOOTER //
// ./src/views/SearchResult/components/SearchInput/SearchInput.tsx